// Client-side CSV export.
// Použití:
//   exportCsv({
//     filename: 'kalibracni-listy.csv',
//     rows: data,
//     columns: [
//       { key: 'certificateNumber', label: 'Číslo' },
//       { key: 'approvedAt', label: 'Datum', format: v => new Date(v).toLocaleDateString('cs-CZ') },
//     ],
//   });

function escapeCell(value) {
  if (value == null) return '';
  const str = String(value);
  // Excel-friendly CSV: pokud obsahuje ; , \n \r " → wrap v "" a double-quote interních ".
  if (/[;,"\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export default function exportCsv({ filename = 'export.csv', rows, columns, delimiter = ';' }) {
  const header = columns.map(c => escapeCell(c.label)).join(delimiter);
  const body = rows.map(row => (
    columns.map(c => {
      const raw = typeof c.key === 'function' ? c.key(row) : row[c.key];
      const formatted = c.format ? c.format(raw, row) : raw;
      return escapeCell(formatted);
    }).join(delimiter)
  )).join('\n');

  // UTF-8 BOM pro Excel — jinak české znaky rozhoží.
  const bom = '﻿';
  const csv = bom + header + '\n' + body;

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
